<template>
  <div>
    <el-card>
      <div class="cardBody">
        <div class="header-row">
          <div class="title-col">
            <div class="title" @click="openPost()">{{post.Titulo}}</div>
          </div>
          <div class="acciones-col">
            <div class="comentarios-container">
              <div class="comentarios-item" @click="openPost()"><el-icon><ChatLineSquare /></el-icon></div>
              <div class="comentarios-item" @click="openPost()">{{post.CantidadComentarios}}</div>
              <div class="archivar-btn" @click="archivar()" v-if="this.post.Instancia != 'Z' && this.idUsuario == this.post.Usuario.Id && this.isHome != true">
                <el-tooltip class="item" effect="dark" :content="$t('FORO_archivar')" placement="left-start">
                  <el-icon><FolderOpened /></el-icon>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="descripcion-row">
          <div class="descripcion">{{post.Descripcion}}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "foroCard",
  props: {
    post: Object,
    isHome: Boolean,
  },
  data() {
    return {
      activeNames: ["1"],
      loading: false,
    };
  },
    computed: {
    ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      })
    },
  methods: {
    openPost()
      {
        this.$emit('openPost', this.post.Id)
      },
      archivar()
      {
        this.$emit('archivar', this.post.Id)
      },
  },
}
</script>

<style scoped>
.title {
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  margin-bottom: 0;
  display: inline-block;
  width: 100%;
}
.header-row {
  display: flex;
  align-items: flex-start;
}
.title-col {
  flex: 0 0 80%;
  width: 80%;
}
.acciones-col {
  flex: 0 0 20%;
  width: 20%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
.comentarios-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 20px;
  line-height: 23px;
  color: #838383;
}
.comentarios-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.archivar-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.descripcion-row {
  margin-top: 10px;
}
.descripcion {
  font-size: 14px;
  line-height: 18px;
  color: #5a5a5a;
}
</style>
